<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div v-else class="disable-text-selection">
            <div class="top-right-button-container">
                <b-button @click="printBill" size="sm" variant="primary">
                    Print
                </b-button>
            </div>

            <div class="d-flex flex-row" >
                <span class="iconsminds-coins mr-3 menu-icon-style" style="font-size: 23px;"/>

                <piaf-breadcrumb :heading="billing.data.attributes.code"/>

<!--                <p class="my-auto">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                    repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                    officiis quia quos rem totam vitae.-->
<!--                </p>-->
            </div>

            <div class="separator mb-4"/>

            <b-row class="invoice-vue" id="print-bill">
                <b-colxx xxs="12">
                    <b-card no-body>
                        <b-card-body class="d-flex flex-column justify-content-between">
                            <div class="d-flex flex-column">
                                <div class="d-flex flex-row justify-content-between mb-5">
                                    <div class="d-flex flex-column w-70 mr-2 p-4 text-semi-muted bg-semi-muted">
                                        <p class="mb-0">Facility Code: {{ billing.data.attributes.facility_code }}</p>
                                        <p class="mb-0">Facility Name: {{ billing.data.attributes.facility_name }}e</p>
                                        <p class="mb-0">Address: {{ billing.data.attributes.facility_address }}</p>
                                    </div>

                                    <div class="d-flex w-30 flex-column text-right p-4 text-semi-muted bg-semi-muted">
                                        <p class="mb-0">Invoice#{{ billing.data.attributes.code }}</p>
                                        <p class="mb-0">Billing Month: {{ billing.data.attributes.period }}</p>
                                        <p class="mb-0">Facility Rate: {{ billing.data.attributes.rate }}</p>
                                        <p class="mb-0">Grand Total: {{ billing.data.attributes.total_days }} days</p>
                                    </div>
                                </div>

                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="text-muted mb-2">#</th>
                                        <th class="text-muted mb-2">UNIT</th>
                                        <th class="text-muted mb-2">CLIENT</th>
                                        <th class="text-muted mb-2">SSN</th>
                                        <th class="text-muted mb-2">MOVED-IN</th>
                                        <th class="text-muted mb-2">MOVED-OUT</th>
                                        <th class="text-muted mb-2">TOTAL DAYS</th>
                                        <th class="text-right text-muted mb-2">AMOUNT</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="(content, index) in billing.data.attributes.contents.data">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ content.data.attributes.unit }}</td>
                                        <td>{{ content.data.attributes.client }}</td>
                                        <td>{{ content.data.attributes.ssn }}</td>
                                        <td>{{ content.data.attributes.moved_in }}</td>
                                        <td>{{ content.data.attributes.moved_out }}</td>
                                        <td>{{ content.data.attributes.total_days }}</td>
                                        <td class="text-right">{{ content.data.attributes.amount }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex flex-column">
                                <div class="border-bottom pt-3 mb-5"></div>
                                <table class="table table-borderless d-flex justify-content-end">
                                    <tbody>
                                    <tr class="font-weight-bold">
                                        <td class="text-semi-muted">Total Payable :</td>
                                        <td class="text-right">{{ billing.data.attributes.total }}</td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div class="border-bottom pt-3 mb-5"></div>

                                <p class="text-muted text-small text-center">
                                    Printed by: {{ billing.data.attributes.printed_by }}, Printed at:
                                    {{ billing.data.attributes.printed_at }}</p>
                            </div>

                        </b-card-body>
                    </b-card>
                </b-colxx>
            </b-row>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: "BillingSummary",
    components: {},

    data() {
        return {
            loading: true,
            themeMode: localStorage.getItem('theme_selected_color').split(".")[0],
        }
    },

    computed: {
        ...mapGetters({
            billing: 'getBilling',
        }),
    },

    mounted() {
        this.getBilling(this.$route.params.billing_id);
    },

    methods: {
        async getBilling(billing_id) {
            await this.$store.dispatch('fetchBilling', billing_id)
                .catch(error => {
                    this.$router.push('/error');
                });

            return this.loading = false;
        },

        printBill() {
            this.$htmlToPaper('print-bill');
        }
    },
}
</script>

<style scoped>

</style>
